__turbopack_context__.v({
  "buttonPrimary__mv24K": "PlasmicSliderForm-module__LQ3RfW__buttonPrimary__mv24K",
  "freeBox___99Hj7": "PlasmicSliderForm-module__LQ3RfW__freeBox___99Hj7",
  "freeBox__khEu": "PlasmicSliderForm-module__LQ3RfW__freeBox__khEu",
  "freeBox__lv9BI": "PlasmicSliderForm-module__LQ3RfW__freeBox__lv9BI",
  "lgTimeFromNow": "PlasmicSliderForm-module__LQ3RfW__lgTimeFromNow",
  "root": "PlasmicSliderForm-module__LQ3RfW__root",
  "svg": "PlasmicSliderForm-module__LQ3RfW__svg",
  "svg__nWhuu": "PlasmicSliderForm-module__LQ3RfW__svg__nWhuu",
  "svg__pmaE4": "PlasmicSliderForm-module__LQ3RfW__svg__pmaE4",
  "text___9EjzB": "PlasmicSliderForm-module__LQ3RfW__text___9EjzB",
  "text__rmkyU": "PlasmicSliderForm-module__LQ3RfW__text__rmkyU",
  "text__unkAi": "PlasmicSliderForm-module__LQ3RfW__text__unkAi",
});
